import { AppConfig } from '../core-bundle/config/app-config';

import Recaptcha from '@module/recaptcha';

export const init = () => {
  Recaptcha.configure({
    element: 'g-recaptcha', // Specify either the ID of the container (string) or the DOM element itself
    sitekey: AppConfig.recaptcha.siteKey,
  });

  // Define the callback methods for Recaptcha
  window.onRecaptchaLoaded = () => {
    Recaptcha.grecaptcha = window.grecaptcha;
    Recaptcha.render();
  };

  // Define the callback methods for Recaptcha
  window.onRecaptchaCallback = (token) => {
    Recaptcha.token = token;
  };
};
